import { serialize } from 'object-to-formdata'
import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  moveTable(id, { hallId, tableNumber }) {
    return axiosIns.put(
      `/waiter/tables/${id}/move`,
      snakecaseKeys({ hallId, tableNumber }),
    )
  },
  getTables({
    date = null,
    interval = null,
    hallId = null,
    tableNumber = null,
    customerTagId = null,
    referralId = null,
    tableId = null,
    endDate = null,
  }) {
    return axiosIns.get(
      '/waiter/tables',
      {
        params: snakecaseKeys({
          date,
          interval,
          hallId,
          tableNumber,
          customerTagId,
          referralId,
          tableId,
          endDate,
        }),
      },
    )
  },
  getTable(tableId) {
    return axiosIns.get(`/waiter/tables/${tableId}`)
  },
  createTable({
    hallId,
    customerCount,
    tableNumber,
    referringHistories,
    vendingHistories,
    customerTableTaggings,
    customerIds,
    confirmReservationConflict = false,
    startAt,
    tableCharge,
    deposits,
  }) {
    const formData = serialize(snakecaseKeys({
      table: {
        hallId,
        customerCount,
        tableNumber,
        ...(startAt ? { startAt } : {}),
        // シングルチャージの上書き指定(率変更・不適用)。未指定時はサーバ側で自動適用判定される
        ...(tableCharge ? { tableCharge } : {}),
        // 卓作成と同時に登録するお預かり金 [{ amount, paymentMethod }]
        ...(deposits && deposits.length > 0 ? { depositsAttributes: deposits } : {}),
        referringHistoriesAttributes: referringHistories,
        vendingHistoriesAttributes: vendingHistories,
        customerTableTaggingsAttributes: customerTableTaggings,
        customerIds,
      },
      confirmReservationConflict,
    }))

    return axiosIns.post(`/waiter/halls/${hallId}/tables/`, formData)
  },
  updateTable({ tableId, params }) {
    const formData = serialize(snakecaseKeys({ table: params }), { allowEmptyArrays: true })

    return axiosIns.put(`/waiter/tables/${tableId}/`, formData)
  },
  revisitTable({
    hallId,
    receiptId,
    customerCount,
    tableNumber,
    referringHistories,
    vendingHistories,
    customerTableTaggings,
    customerIds,
  }) {
    const formData = serialize(snakecaseKeys({
      receiptId,
      table: {
        hallId,
        customerCount,
        tableNumber,
        referringHistoriesAttributes: referringHistories,
        vendingHistoriesAttributes: vendingHistories,
        customerTableTaggingsAttributes: customerTableTaggings,
        customerIds,
      },
    }))

    return axiosIns.put('/waiter/tables/revisit_table', formData)
  },
  calcTotal({
    tableId, price, orderPrice, withBreakdown,
  }) {
    return axiosIns.get(
      `/waiter/tables/${tableId}/calc_total`,
      {
        params: {
          price,
          order_price: orderPrice,
          // 指定するとレスポンスが { total, chargeAmount } のオブジェクトになる
          with_breakdown: withBreakdown ? 1 : undefined,
        },
      },
    )
  },
  calcProcessingFee({ tableId, price }) {
    return axiosIns.get(
      `/waiter/tables/${tableId}/calc_processing_fee`,
      {
        params: {
          price,
        },
      },
    )
  },
  calcFractionAdjustment({ tableId, price }) {
    return axiosIns.get(`/waiter/tables/${tableId}/calc_fraction_adjustment`, { params: { price } })
  },
  // 卓のホールの会計設定(会計手数料の自動適用可否など)。設定がなければ null が返る
  getCheckoutConfig({ tableId }) {
    return axiosIns.get(`/waiter/tables/${tableId}/checkout_config`)
  },
  calcTax({ tableId, price }) {
    return axiosIns.get(`/waiter/tables/${tableId}/calc_tax`, { params: { price } })
  },
  deleteTable(id) {
    return axiosIns.delete(`/waiter/tables/${id}`)
  },

  // セルフオーダー関連API
  selfOrderOpen(tableId) {
    return axiosIns.patch(`/waiter/tables/${tableId}/self_order_open`)
  },
  selfOrderClose(tableId) {
    return axiosIns.patch(`/waiter/tables/${tableId}/self_order_close`)
  },
  getSelfOrderQr(tableId) {
    return axiosIns.get(`/waiter/tables/${tableId}/self_order_qr`)
  },
  // secureモードのQRを再発行する(旧QRは無効になる。注文中のセッションは維持)
  regenerateSelfOrderQr(tableId) {
    return axiosIns.patch(`/waiter/tables/${tableId}/self_order_qr_regenerate`)
  },
}
